import { Grid, Hidden, makeStyles, MenuItem, Select, SelectableChipSmall, Tab, Tabs, useTheme } from '@paintscout/ui'
import type { View } from 'react-big-calendar'
import React, { useEffect, useState } from 'react'
import { setUrlQuery } from 'shared/util/routing'
import { useLocation } from 'react-router-dom'
import Calendar, { CalendarProvider, useCalendar } from '../../common/Calendar'

const useViewSelectStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.paintscout.palette.brand.Neutral.P94,
    borderRadius: theme.borderRadius.lg,
    minWidth: 0,
    '& .MuiSelect-select': {
      border: 'none !important',
      padding: `${theme.spacing(1.25)}px ${theme.spacing(4)}px ${theme.spacing(1.25)}px ${theme.spacing(2)}px`,
      fontSize: theme.typography.pxToRem(14),
      fontWeight: 500,
      color: theme.paintscout.palette.brand.Neutral.P30,
      backgroundColor: 'transparent',
      minHeight: 0,
      lineHeight: 1.5,
      boxShadow: 'none !important'
    },
    '& .MuiSelect-select:focus': {
      backgroundColor: 'transparent',
      borderColor: 'transparent !important',
      boxShadow: 'none !important'
    },
    '& .MuiSelect-icon': {
      color: theme.paintscout.palette.brand.Neutral.P50,
      right: theme.spacing(1)
    }
  }
}))

function ViewChips() {
  const theme = useTheme()
  const { view, setView } = useCalendar()
  const chipStyle = { backgroundColor: theme.paintscout.palette.brand.Neutral.P94 }
  return (
    <>
      <SelectableChipSmall label="Day" selected={view === 'day'} onClick={() => setView('day')} style={chipStyle} />
      <SelectableChipSmall label="Week" selected={view === 'week'} onClick={() => setView('week')} style={chipStyle} />
      <SelectableChipSmall
        label="Month"
        selected={view === 'month'}
        onClick={() => setView('month')}
        style={chipStyle}
      />
    </>
  )
}

function ViewMobileSelect() {
  const { view, setView } = useCalendar()
  const classes = useViewSelectStyles()
  return (
    <Select className={classes.root} value={view} onChange={(e) => setView(e.target.value as View)}>
      <MenuItem value="day">Day</MenuItem>
      <MenuItem value="week">Week</MenuItem>
      <MenuItem value="month">Month</MenuItem>
    </Select>
  )
}

export default function EventsView() {
  const [tab, setTab] = useState<'calendar' | 'map' | 'schedule'>('calendar')
  const location = useLocation()

  useEffect(() => {
    if (location.pathname.includes('map')) {
      setTab('map')
    } else {
      setTab('calendar')
    }
  }, [location.pathname])

  return (
    <CalendarProvider tab={tab}>
      <Grid container justifyContent="space-between" alignItems="center" spacing={1}>
        <Grid item>
          <Tabs
            value={tab}
            onChange={(_, value) => {
              if (value === 'map') {
                location.pathname = '/events/?tab=map'
              } else if (value === 'calendar') {
                location.pathname = '/events/?tab=calendar'
              }
              setUrlQuery({
                location,
                replaceParams: true,
                params: {
                  search: null,
                  filter: null
                }
              })
            }}
          >
            <Tab label="Calendar" value="calendar" onClick={() => setTab('calendar')} />
            <Tab label="Map" value="map" onClick={() => setTab('map')} />
          </Tabs>
        </Grid>

        {(tab === 'calendar' || tab === 'map') && (
          <Hidden xsDown>
            <Grid item xs container justifyContent="flex-end" alignItems="center" style={{ gap: 8 }}>
              <ViewChips />
            </Grid>
          </Hidden>
        )}

        {(tab === 'calendar' || tab === 'map') && (
          <Hidden smUp>
            <Grid item>
              <ViewMobileSelect />
            </Grid>
          </Hidden>
        )}

        <Grid item xs={12}>
          {(tab === 'calendar' || tab === 'map') && <Calendar />}
          {tab === 'schedule' && <div>Schedule</div>}
        </Grid>
      </Grid>
    </CalendarProvider>
  )
}
